import {Component, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {User} from 'projects/core/src/lib/login/data/user';
import {LocalStorage} from 'ngx-webstorage';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {KanbanBoardStore} from '../../../data/kanban-board.store';
import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import {KanbanColumn} from '../../../data/kanban-column';
import {KanbanBoardService} from '../../../data/kanban-board.service';
import {MultiSelect} from 'primeng/multiselect';
import {Preset} from 'projects/app-misc/src/app/modules/admin-panel/data/preset';
import {PresetService} from 'projects/app-misc/src/app/modules/admin-panel/data/preset.service';

@Component({
  selector: 'app-columns-filter',
  templateUrl: './columns-filter.component.html',
  styleUrls: ['./columns-filter.component.scss']
})
export class ColumnsFilterComponent implements OnInit {
  selectedColumns: KanbanColumn[] = [];
  presets: Preset[] = [];
  activePreset: Preset;

  @Output()
  changeDetect = new EventEmitter<any>();

  columns: KanbanColumn[]

  @LocalStorage()
  filteredColumns: number[];

  columnFiltersLabel: string;

  @ViewChild('multiSelect', {static: true})
  multiSelect: MultiSelect


  restrictedColumnsByDefault = new Set(['Lost Projects', 'Project On Hold', 'AC dev', 'COMPLETE']);

  constructor(
    protected projectService: ProjectService,
    protected kanbanBoardService: KanbanBoardService,
    protected kanbanBoardStore: KanbanBoardStore,
    protected presetService: PresetService
  ) {

  }

  ngOnInit(): void {
    this.presetService.getPresets().subscribe(presets => {
      this.presets = presets;
      this.checkActivePreset();
    });

    this.kanbanBoardService.getColumnNames().subscribe(columns => {
      this.columns = columns
      let selectedColumnsIds: number[]

      if (!this.filteredColumns) {
        this.selectedColumns = [...columns];

        for (let i = this.selectedColumns.length - 1; i >= 0; i--) {
          if (this.restrictedColumnsByDefault.has(this.selectedColumns[i].name)) {
            this.selectedColumns.splice(i, 1)
          }
        }

        selectedColumnsIds = this.selectedColumns.map(column => column.id)
      } else {
        const uIds = this.columns.map(user => user.id)
        const fUIds = this.filteredColumns;
        const colsMap = new Map(this.columns.map(col => [col.id, col]));

        selectedColumnsIds = uIds.filter(x => !fUIds.includes(x));
        this.selectedColumns = selectedColumnsIds.map(id => colsMap.get(id));
      }

      this.filteredColumns = this.columns.map(cols => cols.id).filter(colId => !selectedColumnsIds.includes(colId));

      this.kanbanBoardStore.updateColumnsFilter(this.filteredColumns.length > 0 ? selectedColumnsIds : undefined);

      this.countColumns();
      this.checkActivePreset();
    })
  }

  updateColumns(event) {
    const selectedColumnsIds = this.selectedColumns.map(col => col.id)

    this.filteredColumns = this.columns.map(cols => cols.id).filter(colId => !selectedColumnsIds.includes(colId));

    this.kanbanBoardStore.updateColumnsFilter(this.filteredColumns.length > 0 ? selectedColumnsIds : undefined);


    if (selectedColumnsIds.find(colId => colId === event.itemValue.id)) {
      this.kanbanBoardStore.insertColumn(event.itemValue)
    } else {
      this.kanbanBoardStore.deleteColumn(event.itemValue)
    }
    this.countColumns();
    this.checkActivePreset();
  }

  countColumns() {
    this.columnFiltersLabel = this.selectedColumns.length + ' columns selected';

    if (this.selectedColumns.length === this.columns.length) {
      this.columnFiltersLabel = 'Filter Columns';
    }
  }

  applyPreset(preset: Preset) {
    const presetColumnIds = preset.columnsId;
    this.selectedColumns = this.columns.filter(col => presetColumnIds.includes(col.id));

    const selectedColumnsIds = this.selectedColumns.map(col => col.id);
    this.filteredColumns = this.columns.map(cols => cols.id).filter(colId => !selectedColumnsIds.includes(colId));

    this.kanbanBoardStore.updateColumnsFilter(this.filteredColumns.length > 0 ? selectedColumnsIds : undefined);
    this.countColumns();
    this.activePreset = preset;
  }

  showAll() {
    this.multiSelect.toggleAll({})
  }

  checkActivePreset() {
    if (!this.presets || !this.selectedColumns) {
      return;
    }
    const selectedIds = this.selectedColumns.map(c => c.id).sort((a, b) => a - b);

    this.activePreset = this.presets.find(p => {
      if (p.columnsId.length !== selectedIds.length) {
        return false;
      }
      const presetIds = [...p.columnsId].sort((a, b) => a - b);
      return selectedIds.every((value, index) => value === presetIds[index]);
    });
  }

}
